<template>
  <div v-for="(item,index) in recordList" :key="index" style="margin: 8px 0; font-size: 14px; display: flex; flex-wrap: wrap;">
    <span style="margin-right: 8px;">{{item.createTime}}</span>
    <el-tag v-if="type == 2 && item.adminName" size="small" style="margin-right: 8px;">{{item.adminName}}</el-tag>
    <el-tag v-if="type == 1 && item.relationAdminName" size="small" style="margin-right: 8px;">{{item.relationAdminName}}</el-tag>
    <span style="margin-right: 8px;">{{item.content}}</span>
  </div>
</template>

<script>
export default {
  name: "UserLog",
  props: {
    recordList: {
      type: Array,
      default: [],
    },
    type: {
      type: Number,
      default: 1,
    }
  }
}
</script>

<style scoped>

</style>
